var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdmcLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #24348b;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3_for_export") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M500,890.5A390.7,390.7,0,1,1,890.5,500,384.21,384.21,0,0,1,877,601.79,27.5,27.5,0,0,1,850.44,622H697a27.5,27.5,0,0,1-26-18.6l-16.1-47.07L602.65,761.78a27.5,27.5,0,0,1-53.87-2.85L497.5,404,454.09,653.71A27.5,27.5,0,0,1,402.75,662l-46.9-87.76L335.7,608.44A27.49,27.49,0,0,1,312,622H239.5a27.5,27.5,0,0,1,0-55h56.77l37-62.94a27.5,27.5,0,0,1,47.95,1l32.34,60.52,59.32-341.27A27.5,27.5,0,0,1,500,201.5h.39a27.52,27.52,0,0,1,26.83,23.57l56.21,389.08,40.92-160.93A27.5,27.5,0,0,1,677,451.1L716.66,567H828.77a335.27,335.27,0,1,0-34.16,93.66A27.5,27.5,0,1,1,842.87,687,390.66,390.66,0,0,1,500,890.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdmcLogo);
export default __webpack_public_path__ + "static/media/idmc_logo.91601dde8ae7a919915ddcd107cd5ba5.svg";
export { ForwardRef as ReactComponent };